<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-body>
        <base-img
          :src="require('@/assets/abacuslogo.png')"
          contain
          max-width="350"
          min-height="78"
          width="100%"
        />

        <v-divider class="my-7" />
        <base-img
          :src="require('@/assets/treusuisse.png')"
          contain
          max-width="370"
          min-height="78"
          width="100%"
        />
      </base-body>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: 'Bernrainstrasse 1<br>8280 Kreuzlingen',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '+41 71 666 8000',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'info@ifea-treuhand.ch',
        },
      ],
    }),
  }
</script>
